<h1 mat-dialog-title>
  <strong>Application : {{ data.name }}</strong>
</h1>
<div mat-dialog-content>
  <p>Do you wanna change the status of the application : {{ data.name }} ?</p>
  <form [formGroup]="status">
    <mat-form-field color="accent" appearance="outline">
      <mat-label>status</mat-label>
      <mat-select placeholder="Select the new status" formControlName="value" required>
        <mat-option value="verif">verif</mat-option>
        <mat-option value="actif">Actif</mat-option>
        <mat-option value="processing">processing</mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions class="btn-container">
  <button mat-flat-button (click)="onNoClick()">Cancel</button>
  <button mat-flat-button color="accent" (click)="onAction()">Ok</button>
</div>
